module.exports = __webpack_public_path__ + "static/ig_banner_05-8c1a2107b76c8c0c22a321ae1164054c.png";